
export function redactUrl(url: string) {
  try {
    const obj = new URL(url);
    if (obj.password) {
      obj.password = '[pass]';
    }
    if (obj.username) {
      obj.username = '[user]';
    }
    if (obj.search) {
      obj.search = '[query]';
    }

    if (obj.hash) {
      obj.hash = '[hash]';
    }
    return obj.href;
  } catch (ex) {
    url = '[invalid]';
  }
}
